module.exports = __webpack_public_path__ + "static/media/readeo-logo-free-model-alt.4be6a546.svg";